<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="scroll-box">
                <v-container class="modal-container">
                    <v-row>
                        <v-col>
                            <h1>Transação</h1>
                            <v-row v-if="loading">
                                <v-col class="justify-center align-center">
                                    <v-progress-circular :size="35"
                                                        color="primary"
                                                        indeterminate />
                                </v-col>
                            </v-row>
                            <v-row class="top-row">
                                <v-col :title="formatDate(source.tradeDate)">
                                    <div>Neg.: {{ formatDate(source.tradeDate) }}</div>
                                </v-col>
                                <v-col :title="formatDate(source.date)">
                                    <div>Data: {{ formatDate(source.date) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.quantity">
                                    <div>Quant.: {{ source.quantity }}</div>
                                </v-col>
                                <v-col :title="currencyHelper.formatValue(source.value)">
                                    <div>Valor: {{ currencyHelper.formatValue(source.value) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="currencyHelper.formatValue(source.amount)">
                                    <div>Total: {{ currencyHelper.formatValue(source.amount) }}</div>
                                </v-col>
                                <v-col :title="source.type">
                                    <div>Tipo: {{ source.type }}</div>
                                </v-col>
                            </v-row>
                            <v-row class="bottom-row">
                                <v-col :title="source.description">
                                    <div>Descr.: {{ source.description }}</div>
                                </v-col>
                                <v-col :title="source.brokerageNumber">
                                    <div>N. corr.: {{ source.brokerageNumber }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <label>
                                        <input type="checkbox"
                                                title="Status de seleção para adição ao Kristal"
                                                :checked="source && source.import ? 'checked' : ''"
                                                :disabled="loading"
                                                @click="tgStatus($event)" />
                                        Selecionada para adição ao Kristal
                                    </label>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <v-btn icon
            class="close-btn"
            :disabled="loading"
            @click="$emit('close')">
            <img src="@/assets/icons/close.svg"
                alt="dashboard"
                class="icon" />
        </v-btn>
    </div>
</template>

<style scoped>
.close-btn {
  position: fixed;
  top: 6%;
  right: 6%;
}
.modal-mask {
  position: fixed;
  z-index: 22;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0px auto;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-wrapper > .scroll-box {
  max-width: 90% !important;
  width: 90% !important;
  max-height: 90% !important;
  height: 90% !important;
  margin: auto;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
}
.modal-container .row .col .row .col {
    height: 1.8rem;
}
.modal-container > .row > .col > .row > .col > div {
    width: 100%;
    min-width: 100%;
    overflow: hidden;
    height: 1.8rem;
    max-height: 1.8rem;
}
.modal-container .row .col .row .col label input {
    width: 1rem;
    height: 1rem;
}
.top-row {
    margin-top: 0.5rem;
    border-top: 2px solid rgba(0, 0, 128, .75);
}
.bottom-row {
    padding-bottom: 0.75rem;
    border-bottom: 2px solid rgba(0, 0, 128, .75);
}
@media screen and (max-width: 1024px) {
    .close-btn {
        top: 1%;
        right: 6%;
    }
    .modal-container .row {
        flex-direction: column;
    }
    .modal-container .row .col .row .col {
        font-size: 0.75rem;
        height: unset;
        min-height: 1.8rem;
    }
    .modal-wrapper > .scroll-box {
        max-height: unset;
        height: unset;
        min-width: 100% !important;
        max-width: unset;
        width: unset;
        min-height: fit-content;
    }
    .modal-wrapper {
        display: block;
        height: 100%;
        width: 100%;
        overflow: scroll;
    }
}
</style>

<script lang="js">
import ApiService from '../../../../../services/ApiService';
import currencyHelper from '../../../../../Utils/CurrencyHelper';
import percentageHelper from '../../../../../Utils/PercentageHelper';

export default          {
    props               : {
        source          : { type: Object }
    },
    data                () {
        return {
            currencyHelper,
            percentageHelper,
            apiService  : undefined,
            loading     : false
        };
    },
    methods             : {
        formatDate      (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
        },
        async tgStatus  (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            this.loading = true;
            try {
                const userId = this.$store.getters.$tokenUserSelected;
                const resp   = await this.apiService.toggleTransImportStatus(this.source, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                this.source.import = !this.source.import;
            } finally {
                this.loading = false
                return false;
            }
        }
    },
    created             () {
        this.apiService = new ApiService();
    },
    mounted             () {

    },
    beforeDestroy       () {

    }
}
</script>